
import { useEffect, useState } from "react";
import { pricingData } from "../constant/data";
import button from "../../../assets/landingPage/button.svg"

function PricingCard({ plan, isMiddle, isThird, isVsl = false, vid }) {
    const SECONDS_TO_DISPLAY = 10;

    return (
        <div
            className={`relative bg-[#F7F6F4] rounded-lg shadow-lg  h-fit
        ${isMiddle ? "order-1 lg:order-none lg:-mt-8 lg:-mb-8" : ""}
        ${isThird ? "order-2 lg:order-none lg:-mt-3" : ""}
        ${!isMiddle && !isThird ? "order-3 lg:order-none lg:-mt-3" : ""}
    `}
        >
            {/* Best Value Badge */}
            {plan.bestValue && (
                <div className="relative">
                    <div className="ribbon">
                        <p>
                            <span>BEST</span>
                            <span>VALUE</span>
                        </p>
                    </div>
                </div>

            )}
            <div
                className={`text-center rounded-t-lg space-y-3 pt-7 pb-4 ${plan.bestValue
                    ? "bg-gradient-to-b from-[rgba(244,224,169,0)] via-[#eccc75] to-[#ebbf4f]"
                    : "bg-[#85ade1]"
                    }`}
            >
                <h3 className="text-[48px] fon leading-none  text-[#132c4d] uppercase font-black ">
                    {plan.title}
                    <br />
                </h3>

                <p className="text-[30px] font-semibold text-black leading-[45px]">
                    {plan.subtitle}
                </p>
            </div>

            {/* Content */}
            <div
                className={`space-y-1 relative rounded-md ${plan.bestValue ? "bg-[#F7F6F4] px-6 pt-8 " : "bg-[#F7F6F4] px-6 pt-8"
                    }`}>
                {plan.bestValue && (
                    <div className="relative pb-5">
                        {/* Ribbon */}
                        <div className="ribbon2">
                            <p className="text-base">
                                For Today Only Save <span className="font-bold">
                                    EXTRA $15</span>  On This Special Package
                            </p>
                        </div>
                    </div>
                )}
                <img
                    src={plan.product}
                    alt={`${plan.title} Package`}
                    className={`${plan.popular
                        ? 'lg:w-72 w-full '
                        : plan.leastpopular
                            ? ' lg:w-96 w-full mt-5 h-auto'
                            : 'lg:w-80 w-full h-auto mt-5'
                        }  mx-auto hover:opacity-90 ease-in-out duration-300 transition   `}
                />
                {/* Pricing */}
                <div className="text-center space-y-4">
                    <div className="flex items-baseline justify-center gap-1">
                        <span className="text-[55px] leading-none font-bold">${plan.pricePerBottle}</span>
                        <span className="text-gray-800 font-semibold text-2xl">/bottle</span>
                    </div>
                    {/* Features */}
                    {/* <div className="space-y-2">
                        {plan.features.map((feature, idx) => (
                            <div
                                key={idx}
                                className={`p-2 rounded-md xl:text-xl lg:text-lg sm:text-base text-sm font-extrabold uppercase  flex items-center justify-start gap-2 ${feature === "BIGGEST DISCOUNT"
                                    ? "bg-[#DE3C3E] text-white"
                                    : feature === "3 BONUSES"
                                        ? "bg-[#0A203C] text-white"
                                        : feature === "FAST & FREE SHIPPING"
                                            ? "bg-[#146e54] text-white"
                                            : feature === "180 DAY GUARANTEE" ? "bg-[#0090e1] text-white" : "bg-[#0A203C] text-white"
                                    } text-shadow-md`}
                                style={{ textShadow: '0px 1px 6px rgba(0, 0, 0, 0.72)' }}

                            >
                                <img src="https://sinoclear.net/pm/images/check-mark@2x.webp" className="h-6 w-6" />
                                {feature}
                            </div>
                        ))}
                    </div> */}

                    <div className="space-y-1">
                        {plan.shippingfee && (
                            <div className="p-4 py-2  text-[#281c1780]">
                                <p className="lg:text-xl xl:text-2xl text-xl font-bold uppercase">
                                    {plan.shippingfee}
                                </p>
                            </div>
                        )}
                        {plan.youSave && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#204058] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.youSave}
                                </p>
                            </div>
                        )}
                        {plan.discount && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#DE3C3E] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.discount}
                                </p>
                            </div>
                        )}

                        {plan.freeshipping && plan.leastpopular && (
                            <div className="px-4 py-2 mb-12 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#146E54] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.freeshipping}
                                </p>
                            </div>
                        )}
                        {plan.freeshipping && !plan.leastpopular && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#146E54] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.freeshipping}
                                </p>
                            </div>
                        )}

                        {plan.bonuses && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#0A203C] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.bonuses}
                                </p>
                            </div>
                        )}
                        {plan.gurantee && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#0090E1] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.gurantee}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Order Button */}
                <a
                    id="cta-button"
                    href={`${plan.src}${vid ? `&tid=${vid}` : ""}`}
                    onClick={(e) => {
                        const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
                        const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

                        if (alreadyElsDisplayed) {
                            localStorage.removeItem(alreadyDisplayedKey);
                        }
                        const url = `${plan.src}${vid ? `&tid=${vid}` : ""}`;
                        console.log(url);
                    }}
                >
                    <img src={button} className="cursor-pointer" alt="CTA Button" />
                </a>
                {/* Payment Methods */}
                <div className="flex items-center justify-center gap-2 bg-white rounded-md px-4 py-2 shadow-md w-fit mx-auto ">
                    <div className="flex items-center justify-center gap-5">
                        <img src="https://cdn1.breatheagain.io/media/vsl/paymentmethod.webp" />
                    </div>
                </div>
                {/* Pricing */}
                <div className="block text-center mt-6 pb-2">
                    <span className="line-through text-[#132c4d] decoration-red-600 font-semibold text-[26px]">
                        {" "}
                        ${plan.originalPrice}
                    </span>

                    <span className="text-[#132c4d] font-extrabold text-[29px] pl-3">
                        ${plan.discountedPrice}
                    </span>
                </div>
            </div>

        </div>
    )
}
const PricingCards = ({ heading, startTimer, isVsl = false }) => {
    const [timeLeft, setTimeLeft] = useState(15 * 60);
    const [vid, setVid] = useState("");

    useEffect(() => {
        if (window?.clickmagick_cmc?.vid) {
            setVid(window.clickmagick_cmc.vid);
        }
    }, []);
    useEffect(() => {
        if (!startTimer) return;

        const timerInterval = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timerInterval); // Cleanup
    }, [startTimer]);
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    };
    return (
        <>
            <div className="bg-color-offer offer-bg ">
                <div className=" mx-auto  md:px-6 px-4 py-8 max-w-7xl md:mt-10 pt-20">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                        {pricingData.map((plan, index) => (
                            <PricingCard
                                key={index}
                                plan={plan}
                                isMiddle={index === 1}
                                isThird={index === 2}
                                isVsl={isVsl}
                                vid={vid} // 👈 Pass vid to PricingCard


                            />
                        ))}
                    </div>
                </div>
                <div className="flex flex-col gap-5 py-14 max-w-6xl p-2 mx-auto relative z-10">
                    <div className="flex  flex-row items-center md:px-6 px-3">
                        <img
                            src="https://sinoclear.net/pm/images-nw/contact-us.svg"
                            className="w-24 h-auto"
                        />
                        <p className="text-white md:text-[24px] text-[18px]  font-light md:leading-[30px] leading-[20px]">
                            If you are not happy with your purchase for any reason, contact us
                            anytime, and we’ll refund every penny of your investment. You
                            don’t even have to send the bottles back.
                        </p>
                    </div>
                    <a
                        href="https://scalequick.pay.clickbank.net/?cbitems=7&cbur=d"
                        className="text-white cursor-pointer md:text-[24px] text-[24px] text-center md:text-start underline font-light md:px-0 px-3"
                    >
                        <span>
                            <strong className="font-bold"> No Thanks</strong>, I understand
                            that I will never see this offer again. I’d rather pay full price
                            later. Take me to the next page.
                        </span>
                    </a>
                </div>
            </div>

        </>

    )
}
export default PricingCards